import { INDUSTRIES } from "@/data/content";
import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { IndustryCard } from "@/components/home/IndustriesGrid";
import { useSeo } from "@/hooks/useSeo";

export default function Industries() {
  useSeo("Industries | Bodhatek", "Affordable managed IT, dispatch and nationwide onsite support for SMBs, retail, clinics, logistics, professional services and education.");
  return (
    <div data-testid="industries-page">
      <PageHero
        testId="industries-hero"
        eyebrow="Industries"
        lines={["Different sectors.", { text: "Same peace of mind.", className: "text-grad" }]}
        sub="Every business runs differently. We fit our IT, dispatch and onsite support around yours — at a price that makes sense."
      />
      <section className="bg-[#EAF0F7] py-20 sm:py-28">
        <div className="container-x grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind, i) => <IndustryCard key={ind.id} ind={ind} i={i} detailed />)}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
